import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../../atomic/text/Text';
import style from '../IndividualAddTacticPanel.module.css';

export const AddBreakPriceHeader = () => {
  return (
    <thead>
      <tr style={{ backgroundColor: colors.grey }}>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            #
          </Body3>
        </th>
        <th className={style.valueHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Break Price
          </Body3>
        </th>
        <th className={style.fieldHeader}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Add/Remove
          </Body3>
        </th>
      </tr>
    </thead>
  );
};
